import { openModal } from '~/actions/settings-packages.actions';
import ParcelSelect, {
  ParcelSelectDispatchProps,
  ParcelSelectField,
  ParcelSelectStateProps,
} from '~/components/ParcelSelect';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import {
  getCarrierParcelTemplates,
  getParcelTemplates,
  isLoadingParcels,
} from '~/selectors/parcel-template.selectors';
import { ApplicationState } from '../../store';

const mapStateToProps = (state: ApplicationState): ParcelSelectStateProps => {
  return {
    parcelTemplates: getParcelTemplates(state),
    carrierParcelTemplates: getCarrierParcelTemplates(state),
    isLoadingParcels: isLoadingParcels(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch): ParcelSelectDispatchProps => {
  return {
    openSavePackageTemplateModal: () => dispatch(openModal()),
  };
};

const ComposedParcelSelect = connect(mapStateToProps, mapDispatchToProps)(ParcelSelect);

export default ComposedParcelSelect;

export const ParcelSelectFieldContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ParcelSelectField);
